import { useMutation } from "@tanstack/react-query";

import { usersKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useArchiveUser(userId: number | undefined) {
  return useMutation({
    mutationFn: async () =>
      await apiClient.url(`/users/archive/${userId}`).patch().json(),
    mutationKey: usersKeys.archive(userId),
  });
}
